import React, { Component } from "react";
import { getTabs, getTabStatus } from "../../../services/formService";
import CustomLoader from "../../common/Loader";
import FormViewer from "../FormViewer";
import { toaster } from '../../../config';
import { getIdentity, isNullOrEmpty } from "../../common/commonFuncs";
import { Markup } from "interweave";
import { getProjectFormAccess } from "../../../services/projectService";
import {logActivity} from "../../../services/utilService";

class TabViewer extends Component {
    state = {
        Widget_ID: this.props.Widget_ID,
        Tabs: [{Tab_ID: -1, Tab_Name: "", Tab_Form_ID: ""}],
        selected_tab: 0,
        loading: true,
        selectedInst: this.props.selectedInst,
        triggerRender: this.props.triggerRender ? this.props.triggerRender : false,
        PrimaryKey: this.props.PrimaryKey,
        PK_Name: this.props.PK_Name ? this.props.PK_Name : null,
        Question_Number: this.props.Question_Number ? this.props.Question_Number : 0,
        SurveyMode: this.props.SurveyMode,
        Project_ID: this.props.Project_ID ? this.props.Project_ID : 0,
    };

    async componentDidMount() {
        // get tabs and current user's form permissions
        Promise.all([getProjectFormAccess(getIdentity(), this.state.Project_ID), getTabs(this.props.Widget_ID)])
            .then(responses => {
                const [formAccessResponse, tabResponse] = responses;
                let formAccessData = formAccessResponse.data;
                let tabData = tabResponse.data;
                if (typeof formAccessData === 'string') throw new Error(formAccessData);
                if (typeof tabData === 'string') throw new Error(tabData);

                // filter tabs by access type (Edit/View/Hide)
                let Tabs = [];
                for (let i = 0; i <tabData.length; i++) {
                    let formAccess = formAccessData.find(f => f.Form_ID === tabData[i].Tab_Form_ID);

                    // if access type is view, set tab property isViewOnly true
                    tabData[i].isViewOnly = formAccess?.Access_Type === 'View';

                    // Show tab as long as access type is not hide
                    if (formAccess?.Access_Type !== 'Hide') {
                        Tabs.push(tabData[i]);
                    }
                }
                this.setState({Tabs});
            })
            .then(() => {
                this.updateTabStatuses();
            })
            .then(() => {
                let tab_idx = 0;
                if (window.location.hash) {
                    let tab_form_id = window.location.hash.split("=")[1];
                    tab_idx = this.state.Tabs.map(t => t.Tab_Form_ID).indexOf(parseInt(tab_form_id));
                };
                this.handleTab(tab_idx === -1 ? 0 : tab_idx) &&
                this.setState({loading: false});
            })
            .catch(e => {
              toaster('error', String(e));
              logActivity(window.location.href.substring(window.location.origin.length), 'TABVIEWER_LOAD_FAILED')
            });
    }

    /**
     * Go through each tab and check if a locking stored procedure has been configured,
     * if so, execute locking stored procedure to check whether to mark tab as disabled
     */
    updateTabStatuses = async () => {
        let Tabs = this.state.Tabs;
        Tabs.forEach((tab, idx) => {
            if (!isNullOrEmpty(tab['Locking_StoredProcedure'])) {
                getTabStatus(tab, this.state.PrimaryKey, this.state.PK_Name)
                    .then((response) => {
                        let tabStatus = response.data;
                        if (tabStatus.includes("unlocked")) {
                            Tabs[idx]['isDisabled'] = false;
                        } else {
                            Tabs[idx]['isDisabled'] = true;
                        }
                        this.setState({Tabs});
                    })
                    .catch(e => {
                        toaster('error', String(e));
                        logActivity(window.location.href.substring(window.location.origin.length),
                            'TABVIEWER_UPDATE_TAB_STATUS_FAILED')
                    });
            }
        })
    }

    handleTab = (idx) => {
        let selected_tab = idx; // not setting state here to prevent remounting of FormViewer
        let Tabs = this.state.Tabs, tab = this.state.Tabs[idx],
            ActiveForm = <p>Please fill dependent tabs and don't forget return to this tab!</p>;
        if (this.props.closePopUpForm === undefined) {
            window.location.hash = '#tab_form_id=' + tab.Tab_Form_ID;
        }
        if (!isNullOrEmpty(tab['Locking_StoredProcedure'])) {
            /* check tab status and block/unblock tab */
            let tabStatus = false;
            (getTabStatus(tab, this.state.PrimaryKey, this.state.PK_Name))
                .then((response) => {
                    tabStatus = response.data;
                    return tabStatus;
                })
                .then((tabStatus) => {
                    if (tabStatus.includes("unlocked")) {
                        ActiveForm =
                            <FormViewer
                                key={selected_tab}
                                PrimaryKey={this.state.PrimaryKey}
                                PK_Name={this.state.PK_Name}
                                Form_ID={tab.Tab_Form_ID}
                                source={this.props.source}
                                selectedInst={this.state.selectedInst}
                                Responses={this.props.Responses}
                                Project_ID={this.state.Project_ID}
                                isTab={true}
                                changeTab={this.changeTab}
                                Form_SecondaryIDName={this.props.Form_SecondaryIDName}
                                Form_SecondaryIDValue={this.props.Form_SecondaryIDValue}
                                updateTabStatuses={this.updateTabStatuses}
                                closePopUpForm={this.props.closePopUpForm ? this.props.closePopUpForm : undefined}
                                isViewOnly={tab.isViewOnly || false}
                            />
                        Tabs[idx]['isDisabled'] = false;
                    } else {
                        Tabs[idx]['isDisabled'] = true;
                        ActiveForm = <Markup content={tabStatus}/>
                    }
                    // else {
                    //   let depTabs = '';
                    //   this.state.Tabs.forEach((t) => {
                    //     if (JSON.parse(tab['Tab_DependentTabs']).find((dt => dt.Tab_Form_ID === t.Tab_Form_ID))) {
                    //       depTabs = depTabs + (depTabs.length > 0 ? ', ' : '') + t.Tab_Name
                    //     }
                    //   })
                    //   ActiveForm = <span className='text-danger'>Please record valid responses on Dependent Tabs ({depTabs}) and do not forget to return to this tab.</span>
                    // }
                    this.setState({Tabs});
                    this.setState({ActiveForm});
                    this.setState({selected_tab: idx});
                });
        } else {
            ActiveForm =
                <FormViewer
                    key={selected_tab}
                    PrimaryKey={this.state.PrimaryKey}
                    PK_Name={this.state.PK_Name}
                    Form_ID={tab.Tab_Form_ID}
                    source={this.props.source}
                    selectedInst={this.state.selectedInst}
                    Responses={this.props.Responses}
                    Project_ID={this.state.Project_ID}
                    isTab={true}
                    changeTab={this.changeTab}
                    Form_SecondaryIDName={this.props.Form_SecondaryIDName}
                    Form_SecondaryIDValue={this.props.Form_SecondaryIDValue}
                    updateTabStatuses={this.updateTabStatuses}
                    closePopUpForm={this.props.closePopUpForm ? this.props.closePopUpForm : undefined}
                    isViewOnly={tab.isViewOnly || false}
                />
            this.setState({ActiveForm});
            this.setState({selected_tab: idx});
        }
        this.setState({loading: false});
    };

    /**
     * Changes active tab.
     * Passed as a prop to FormViewer for handling "Save and Continue" button.
     * @param {int} formId
     */
    changeTab = (formId) => {
        // find the index of Tabs that has matching form id
        let tabIndex = this.state.Tabs.findIndex((tab) => tab.Tab_Form_ID === formId);
        if (tabIndex === -1) {
            toaster('warning', 'Save and Continue redirect is missing form id or there is no matching form tab');
            return;
        }
        this.handleTab(tabIndex);
        window.scrollTo(0, 0);
    };

    render() {
        if (this.state.loading) {
            return <CustomLoader loading={this.state.loading}/>;
        }
        const {Tabs} = this.state;
        return (
            <div className="card mb-4" key={this.state.selected_tab}>
                <div className="card-header">
                    <ul className="nav nav-tabs card-header-pills" role="tablist" key={this.state.selected_tab}>
                        {Tabs.map((tab, idx) => {
                            return (
                                <li className="nav-item" key={idx}>
                                    <a
                                        href={"#" + tab.Tab_Name}
                                        className={
                                            "nav-link"
                                            + (idx === this.state.selected_tab ? " active" : "")
                                            + (tab['isDisabled'] ? ' dependentTab' : '')
                                        }
                                        key={"tab" + tab.Tab_ID}
                                        data-toggle="tab"
                                        role="tab"
                                        aria-controls={tab.Tab_Name}
                                        onClick={() => this.handleTab(idx)}
                                    >
                                        {tab.Tab_Name}
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </div>
                <div className="card-body">
                    <div className="tab-content">
                        {this.state.ActiveForm}
                    </div>
                </div>
            </div>
        );
    }
}

export default TabViewer;
